<template>
  <div class="accordion-item">
    <button
      class="accordion-button py-3 px-4 w-full text-left font-semibold flex items-center justify-between"
      @click="isOpen = !isOpen"
    >
      {{ title }}
      <span :class="{ 'rotate-180': isOpen }">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 transition-transform duration-300"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>
    <div
      class="accordion-content border-t border-gray-200 overflow-hidden transition-max-height duration-300"
      :style="{ maxHeight: isOpen ? '500px' : '0' }"
    >
      <div class="py-2 px-4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'AccordionComponent',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup() {
    const isOpen = ref(false);

    return {
      isOpen
    }
  }
}
</script>

<style scoped>
.accordion-button {
  background-color: #fff;
  border: none;
  cursor: pointer;
}

.accordion-content {
  max-height: 0;
}
</style>